<template>
    <div>
        <app-data-table ref="exhbitors-table" :fields="fields" resource="event-exhibitors" :hard-filters="hardFilters" row-details>
            <template #buttons>
                <app-btn-create @click="openModal('exhibitor-form-window')"><i class="fas fa-plus"></i> Crear Expositor</app-btn-create>
            </template>
            <template #row-details="{ item }">
                <h5>Perfil</h5>
                <b-row>
                    <b-col cols="12" lg="auto">
                        <img :src="item.photo_url" alt="" class="profile-photo" />
                    </b-col>
                    <b-col cols="12" lg="auto" class="ml-3">
                        <img :src="item.qr_url" alt="" class="profile-photo" />
                    </b-col>
                    <b-col cols="12" lg="12">
                        <div v-html="item.profile"></div>
                    </b-col>
                </b-row>
            </template>
            <template #cell(actions)="{ toggleDetails }">
                <div class="d-flex align-items-center flex-wrap">
                    <b-btn size="sm" variant="primary" @click="toggleDetails"><i class="fas fa-eye"></i></b-btn>
                </div>
            </template>
        </app-data-table>

        <app-modal
            id="exhibitor-form-window"
            title="Formulario de expositor"
            :ok-disabled="busy"
            ok-title="Guardar"
            size="lg"
            @ok="$refs['exhibitor-form'].save()"
        >
            <app-event-exhibitor-form
                :event="currentEvent"
                ref="exhibitor-form"
                @busy="(_busy) => (busy = _busy)"
                @success="exhibitorSaved"
            ></app-event-exhibitor-form>
        </app-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import appEventExhibitorForm from './EventExhibitorForm'
export default {
    components: {
        appEventExhibitorForm,
    },
    data: () => ({
        fields,
        busy: false,
    }),
    computed: {
        ...mapGetters(['currentEvent']),
        hardFilters() {
            return {
                eventId: this.currentEvent.id,
                sortBy: 'name',
                sortDir: 'asc',
            }
        },
    },
    methods: {
        exhibitorSaved() {
            this.closeModal('exhibitor-form-window')
            this.$refs['exhbitors-table'].refresh()
        },
    },
}

const fields = [
    {
        key: 'name',
        label: 'Nombre',
    },
    {
        key: 'document',
        label: 'Document',
    },
    {
        key: 'email',
        label: 'E-mail',
    },
    {
        key: 'code',
        label: 'Código',
    },
    {
        key: 'profession',
        label: 'Profesión',
    },
    {
        key: 'phone',
        label: 'Teléfono',
    },
    {
        key: 'country',
        label: 'País',
    },
    {
        key: 'city',
        label: 'Ciudad',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>

<style scoped>
.profile-photo {
    max-width: 100%;
    max-height: 250px;
}
</style>
